import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "work-item-card" }
const _hoisted_2 = { class: "card-details" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "mini-task-list"
}
const _hoisted_7 = { class: "card-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-label",
        title: $setup.props.taskCard.CardProjection.CardTitle
      }, _toDisplayString($setup.props.taskCard.CardProjection.CardTitle), 9 /* TEXT, PROPS */, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass(["card-status", $setup.props.taskCard.Status.toLowerCase()])
      }, _toDisplayString($setup.props.taskCard.Status), 3 /* TEXT, CLASS */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      ($setup.props.taskCard.CardProjection.CardBody)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "card-body-content",
            innerHTML: $setup.props.taskCard.CardProjection.CardBody
          }, null, 8 /* PROPS */, _hoisted_5))
        : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.taskCard.Tasks, (task) => {
              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(task.Config.Name), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        value: "Open Tasks",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleClick($setup.props.taskCard)))
      }, [
        _createVNode($setup["Resource"], { res: "home_opentasks" })
      ])
    ])
  ]))
}